/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NutritionMilkAndDerivativesViewFragmentAliases {
  CONTEXTUAL_MILK_AND_DERIVATIVES = 'contextual-milk-and-derivatives',
  FIELD_ADMINISTRATION = 'field-administration',
  FIELD_DURATION = 'field-duration',
  FIELD_DURATION_H_MIN = 'field-duration-h-min',
  FIELD_END_DATE = 'field-end-date',
  FIELD_HOURS = 'field-hours',
  FIELD_INFUSION_RATE = 'field-infusion-rate',
  FIELD_INFUSION_RATE_UNIT_OF_MEASUREMENT = 'field-infusion-rate-unit-of-measurement',
  FIELD_INTERVAL = 'field-interval',
  FIELD_ITEM = 'field-item',
  FIELD_ITEM_1 = 'field-item-1',
  FIELD_ITEM_1_DOSE = 'field-item-1-dose',
  FIELD_ITEM_1_UNIT_MEASURE = 'field-item-1-unit-measure',
  FIELD_ITEM_2 = 'field-item-2',
  FIELD_ITEM_2_DOSE = 'field-item-2-dose',
  FIELD_ITEM_2_UNIT_MEASURE = 'field-item-2-unit-measure',
  FIELD_ITEM_3 = 'field-item-3',
  FIELD_ITEM_3_DOSE = 'field-item-3-dose',
  FIELD_ITEM_3_UNIT_MEASURE = 'field-item-3-unit-measure',
  FIELD_ITEM_4 = 'field-item-4',
  FIELD_ITEM_4_DOSE = 'field-item-4-dose',
  FIELD_ITEM_4_UNIT_MEASURE = 'field-item-4-unit-measure',
  FIELD_ITEM_DOSE = 'field-item-dose',
  FIELD_ITEM_UNIT_MEASURE = 'field-item-unit-measure',
  FIELD_JUSTIFICATION = 'field-justification',
  FIELD_NUTRITION = 'field-nutrition',
  FIELD_OBSERVATION = 'field-observation',
  FIELD_PERCENTAGE_1 = 'field-percentage-1',
  FIELD_PERCENTAGE_2 = 'field-percentage-2',
  FIELD_PERCENTAGE_3 = 'field-percentage-3',
  FIELD_PERCENTAGE_4 = 'field-percentage-4',
  FIELD_PRESCRIBER_DATE = 'field-prescriber-date',
  FIELD_PRESCRIBER_NAME = 'field-prescriber-name',
  FIELD_ROUTE = 'field-route',
  FIELD_START_DATE = 'field-start-date',
  FIELD_SUCTION_DEVICE = 'field-suction-device',
  FIELD_TEMPERATURE = 'field-temperature',
  FIELD_TOTAL_VOLUME = 'field-total-volume',
  FIELDSET_ITEM_1 = 'fieldset-item-1',
  FIELDSET_ITEM_2 = 'fieldset-item-2',
  FIELDSET_ITEM_3 = 'fieldset-item-3',
  FIELDSET_ITEM_4 = 'fieldset-item-4',
  FORM_ADDITIONAL_INFORMATION = 'form-additional-information',
  FORM_ADMINISTRATION_INFORMATION = 'form-administration-information',
  FORM_MAIN_INFORMATIONS = 'form-main-informations',
  FORM_PERIOD_OF_VALIDITY = 'form-period-of-validity',
  FRAGMENT_REFERENCE_BAR_HEADER = 'fragment-reference-bar-header',
  INPUT_END_DATE = 'input-end-date',
  INPUT_START_DATE = 'input-start-date',
  LAYOUT_MILK_AND_DERIVATIVES_PRODUCTS = 'layout-milk-and-derivatives-products',
  LOADER = 'loader',
  PANEL_CONTENT = 'panel-content',
  PANEL_LOADER = 'panel-loader',
  SECTION_ADDITIONAL_INFORMATION = 'section-additional-information',
  SECTION_ADMINISTRATION_INFORMATION = 'section-administration-information',
  SECTION_MAIN_INFORMATIONS = 'section-main-informations',
  SECTION_PERIOD_OF_VALIDITY = 'section-period-of-validity',
  SUPPRESS_HEADING_MARGIN_ADDITIONAL_INFORMATION = 'suppress-heading-margin-additional-information',
  SUPPRESS_HEADING_MARGIN_ADMINISTRATION_INFORMATION = 'suppress-heading-margin-administration-information',
  SUPPRESS_HEADING_MARGIN_MAIN_INFORMATIONS = 'suppress-heading-margin-main-informations',
  SUPPRESS_HEADING_MARGIN_PERIOD_OF_VALIDITY = 'suppress-heading-margin-period-of-validity',
  TEXT_ADMINISTRATION = 'text-administration',
  TEXT_DURATION = 'text-duration',
  TEXT_DURATION_H_MIN = 'text-duration-h-min',
  TEXT_HOURS = 'text-hours',
  TEXT_INFUSION_RATE = 'text-infusion-rate',
  TEXT_INFUSION_RATE_UNIT_OF_MEASUREMENT = 'text-infusion-rate-unit-of-measurement',
  TEXT_INTERVAL = 'text-interval',
  TEXT_ITEM = 'text-item',
  TEXT_ITEM_1 = 'text-item-1',
  TEXT_ITEM_1_DOSE = 'text-item-1-dose',
  TEXT_ITEM_1_UNIT_MEASURE = 'text-item-1-unit-measure',
  TEXT_ITEM_2 = 'text-item-2',
  TEXT_ITEM_2_DOSE = 'text-item-2-dose',
  TEXT_ITEM_2_UNIT_MEASURE = 'text-item-2-unit-measure',
  TEXT_ITEM_3 = 'text-item-3',
  TEXT_ITEM_3_DOSE = 'text-item-3-dose',
  TEXT_ITEM_3_UNIT_MEASURE = 'text-item-3-unit-measure',
  TEXT_ITEM_4 = 'text-item-4',
  TEXT_ITEM_4_DOSE = 'text-item-4-dose',
  TEXT_ITEM_4_UNIT_MEASURE = 'text-item-4-unit-measure',
  TEXT_ITEM_DOSE = 'text-item-dose',
  TEXT_ITEM_UNIT_MEASURE = 'text-item-unit-measure',
  TEXT_JUSTIFICATION = 'text-justification',
  TEXT_NUTRITION = 'text-nutrition',
  TEXT_NUTRITIONAL_CALORIC_PROFILE = 'text-nutritional-caloric-profile',
  TEXT_NUTRITIONAL_CALORIC_PROFILE_1 = 'text-nutritional-caloric-profile-1',
  TEXT_OBSERVATION = 'text-observation',
  TEXT_PERCENTAGE_1 = 'text-percentage-1',
  TEXT_PERCENTAGE_2 = 'text-percentage-2',
  TEXT_PERCENTAGE_3 = 'text-percentage-3',
  TEXT_PRESCRIBER_DATE = 'text-prescriber-date',
  TEXT_PRESCRIBER_NAME = 'text-prescriber-name',
  TEXT_SUCTION_DEVICE = 'text-suction-device',
  TEXT_TEMPERATURE = 'text-temperature',
  TEXT_TOTAL_VOLUME = 'text-total-volume',
}
export { NutritionMilkAndDerivativesViewFragmentAliases };
